import React from "react";
import { Box, Typography } from "@mui/material";
import vipin from "../assets/images/vipin_png.png";

const VisionSection = () => {
  return (
    <Box
      id="aboutGlobalReach"
      sx={{
        backgroundColor: "#0f2142",
        color: "#fff",
        py: { xs: 4, md: 6 },
        px: { xs: 2, sm: 4, md: 8 },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          alignItems: "center",
          gap: { xs: 4, md: 6 },
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* LEFT SIDE - IMAGE + QUOTE MARKS (50%) */}
        <Box
          sx={{
            flex: "0 0 50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
          }}
        >
          {/* Circular Image */}
          <Box
            component="img"
            src={vipin}
            alt="VIPIN YADAV"
            sx={{
              width: { xs: "80%", sm: "70%", md: "90%" },
              maxWidth: 437,
              height: "auto",
              objectFit: "cover",
              zIndex: 1,
              position: "relative",
            }}
          />
        </Box>

        {/* RIGHT SIDE - TEXT (50%) */}
        <Box
          sx={{
            flex: "0 0 50%",
            textAlign: { xs: "center", md: "left" },
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: "14px", sm: "15px", md: "15px" },
              lineHeight: 1.9,
              opacity: 0.9,
              mb: 3,
            }}
          >
            At Dure Technologies, we envision a future where{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              healthcare and technology seamlessly merge to transform global
              settings.
            </Box>
            <br />
            <br />
            As a trusted partner in over{" "}
            <Box component="span" sx={{ fontWeight: 700 }}>
              50 countries
            </Box>
            , we lead this transformation through digital innovation. By
            leveraging AI, fostering local ownership, and ensuring global
            proficiency, we aim to redefine digital health, data science, and
            climate resilience.
            <br />
            <br />
            Our Centers of Excellence and country hubs ensure advancements reach
            every corner of the world, driving impactful change at scale.
          </Typography>

          <Typography
            sx={{
              color: "#FFC107",
              fontWeight: "bold",
              fontSize: { xs: "18px", md: "22px" },
              letterSpacing: 1,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            VIPIN YADAV
          </Typography>

          <Typography
            sx={{
              opacity: 0.8,
              mt: 0.5,
              textAlign: { xs: "center", md: "left" },
            }}
          >
            CEO & Founder
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default VisionSection;
